import { GenericRadioChoiceStep } from '@eneco/flows/components';
import { FlowRoute, FlowRouteCategory } from '@eneco/flows/types';

import { FlowContextDeceased } from '../context';
import { DeceaseDate } from './steps/DeceaseDate';
import { DeceasedContactPersonDetails } from './steps/DeceasedContactPersonDetails';
import { KeyHandOver } from './steps/KeyHandOver';
import { MonthlyInstallmentPaymentMethodStep } from './steps/MonthlyInstallmentPaymentMethodStep';
import { PersonSearch } from './steps/PersonSearch';
import { Summary } from './steps/Summary';

export const initialContext: FlowContextDeceased = {};

export const actions = {};

export const routes: FlowRoute<FlowContextDeceased>[] = [
  {
    id: 'CONTRACT',
    path: '/contract/',
    category: FlowRouteCategory.Contract,
    component: GenericRadioChoiceStep,
  },
  {
    id: 'DECEASED_DETAILS',
    path: '/persoonsgegevens/',
    category: FlowRouteCategory.Details,
    component: PersonSearch,
  },
  {
    id: 'DECEASE_DATE',
    path: '/datum-overlijden/',
    category: FlowRouteCategory.Details,
    component: DeceaseDate,
  },
  {
    id: 'KEY_HANDOVER',
    path: '/sleuteloverdracht/',
    category: FlowRouteCategory.Details,
    component: KeyHandOver,
  },
  {
    id: 'CONTACT_DETAILS',
    path: '/contactgegevens/',
    category: FlowRouteCategory.Details,
    component: DeceasedContactPersonDetails,
  },
  {
    id: 'INSTALLMENT',
    path: '/termijnbedrag/',
    category: FlowRouteCategory.Summary,
    component: MonthlyInstallmentPaymentMethodStep,
  },
  {
    id: 'SUMMARY',
    path: '/overzicht/',
    category: FlowRouteCategory.Summary,
    component: Summary,
  },
];
